<div class="padding-bottom-10">
  <gs-form change *ngIf="item && properties && properties.length"
           [item]="item"
           [properties]="properties"
           [showSubmit]="false"
           (onChange)="propertyChange($event)">
  </gs-form>
</div>
